import React, { useState, useEffect } from "react";
import columns from "../../../columns/PaymentGatway";
import ConfirmationModal from "../../../components/global/modal/ConfirmationModal.jsx";
import Pagination from "../../../components/global/pagination/Pagination.jsx";
import { GetAllPaymentGatwaysApi, UpdatePaymentGatwayStatusApi, UpdategetwayApi } from "../../../api/request/settings/paymentGatway.js";
import TableWithSkeleton from "../../../components/global/table/TableWithSkeleton";
import toast from "react-hot-toast";
import Edit from "../../../assets/Edit.jsx";
import ModalComponent from "../../../components/global/modal/ModalComponent.jsx";
import { Select, Form, Switch, Input, Upload, Image } from "antd";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";
import { useSelector } from "react-redux";

export default function PaymentGatway() {
  const userDetails = useSelector((state) => state.user.userDetails);
  let isSalesManager = userDetails?.roleId === 6;

  const [form] = Form.useForm();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedPaymentGatway, setSelectedPaymentGatway] = useState(null);
  const [isStatusConfirmOpen, setIsStatusConfirmOpen] = useState(false);
  const [isStatusConfirmLoading, setIsStatusConfirmLoading] = useState(false);
  const [selectedid, setSelectedid] = useState(null);
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [isEditTraderLoading, setIsEditTraderLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [showQrField, setShowQrField] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  const selectedGateway = data?.find((item) => item?.id === selectedid);
  const showCryptoAddressField = selectedGateway?.cryptoAddress != null;

  const statusHandler = (value) => {
    setSelectedPaymentGatway(value);
    setIsStatusConfirmOpen(true);
  }

  const getPaymentGatways = async () => {
    try {
      setIsLoading(true);
      let params = {
        PageNumber: page,
        PageSize: pageSize,
      }
      const { data } = await GetAllPaymentGatwaysApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              // fees:`$ ${item?.fees}`,
              status: <Switch onChange={() => statusHandler(item)} checkedChildren="Active" unCheckedChildren="Inactive" checked={item?.isActive} />,
              action: (
                <button type="button" onClick={() => handleEditClick(item)}>
                  <Edit />
                </button>
              ),
            }
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setData([]);
      setIsLoading(false);
    }
  }

  const statusChangeConfirm = async () => {
    try {
      setIsStatusConfirmLoading(true);

      let params = {
        Status: !selectedPaymentGatway?.isActive
      }

      const { data } = await UpdatePaymentGatwayStatusApi(selectedPaymentGatway?.id, new URLSearchParams(params).toString());
      if (data?.success) {
        getPaymentGatways();
        toast.success(data?.message);
      }

      setIsStatusConfirmLoading(false);
      setIsStatusConfirmOpen(false);
    } catch (error) {
      setIsStatusConfirmLoading(false);
    }
  }

  useEffect(() => {
    getPaymentGatways();
  }, [page, pageSize]);

  const handleEditClick = (item) => {
    setSelectedid(item?.id);
    setShowQrField(!!item?.qrCodeUrl);
    const qrList = item?.qrCodeUrl ? [{ uid: "-1", url: item.qrCodeUrl }] : [];
    setFileList(qrList);

    const parseProcessing = (input) => {
      if (input == null) return { value: 0, unit: "H" };
      const str = String(input).trim();
      const match = str.match(/^(\d+(?:\.\d+)?)\s*([A-Za-z]+)?$/);
      if (!match) return { value: Number(str) || 0, unit: "H" };
      const value = parseFloat(match[1]);
      const token = (match[2] || "H").toUpperCase();
      const unit = token.startsWith("M") ? "M" : "H";
      return { value, unit };
    };

    const { value: procTime, unit: procUnit } = parseProcessing(item?.processingTime);

    form.setFieldsValue({
      paymentMethodName: item?.paymentMethodName ?? item?.name ?? "",
      processingTime: procTime,
      processingUnit: procUnit,
      fees: parseFloat(item?.fees) || 0,
      description: item?.description || "",
      cryptoAddress: item?.cryptoAddress ?? "",
      uploadQRCode: qrList,
    });
    setIsOpenEditModal(true);
  };

  const handleEditSubmit = async (value) => {
    try {
      let formData = new FormData();
      const qrItem = value?.uploadQRCode?.[0];
      const newFile = qrItem?.originFileObj;
      if (newFile) {
        formData.append("UploadQRCode", newFile);
      }
      formData.append("PaymentMethodName", value?.paymentMethodName);
      formData.append(
        "ProcessingTime",
        `${value.processingTime} ${value.processingUnit}`
      );
      formData.append("Fees", parseFloat(value?.fees) || 0);
      formData.append("Description", value?.description);
      if (showCryptoAddressField && value?.cryptoAddress != null) {
        formData.append("cryptoAddress", value.cryptoAddress);
      }
      let headers = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      setIsEditTraderLoading(true);
      const { data } = await UpdategetwayApi(selectedid, formData, headers);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        setFileList([]);
        setIsEditTraderLoading(false);
        setIsOpenEditModal(false);
        getPaymentGatways();
      }
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsEditTraderLoading(false);
    }
  };

  const handleQrChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    form.setFieldsValue({ uploadQRCode: newFileList });
    if (newFileList?.length === 0) {
      form.setFieldsValue({ uploadQRCode: [] });
    }
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const UploadButton = (
    <button type="button">
      <div className="flex justify-center">
        <img src="assets/icons/Upload_Document_icon.svg" alt="icon" />
      </div>
      Upload
    </button>
  );

  return (
    <div>
      <div>
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
          <TableWithSkeleton
            columns={columns}
            data={data}
            loading={isLoading}
            hiddenColumns={isSalesManager ? ["Actions", "Status"] : []}
            page={page}
            pageSize={pageSize}
          />
        </div>
        <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
      </div>

      {/* Payment gatway status change confirmation modal */}
      <ConfirmationModal
        isOpen={isStatusConfirmOpen}
        setIsOpen={setIsStatusConfirmOpen}
        message='Are you sure to change the payment gatway status?'
        onConfirm={statusChangeConfirm}
        isLoading={isStatusConfirmLoading}
        loadingLabel='Changing status...'
      />

      {/* Update payment gateway modal */}
      <ModalComponent
        isOpen={isOpenEditModal}
        setIsOpen={setIsOpenEditModal}
        title="Update Payment Gateway"
        width={500}
      >
        <Form
          className="w-full"
          autoComplete="off"
          form={form}
          onFinish={handleEditSubmit}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <p className="font-semibold mb-[2px]">Payment Method Name</p>
              <Form.Item
                name="paymentMethodName"
                rules={[
                  {
                    required: true,
                    message: "Please enter payment method name",
                  },
                ]}
              >
                <Input
                  placeholder="Enter payment method name"
                  className="w-full mt-1"
                  disabled={true}
                />
              </Form.Item>
            </div>
            <div>
              <p className="font-semibold mb-[2px]">Processing Time</p>
              <Form.Item
                name="processingTime"
                rules={[
                  {
                    required: true,
                    message: "Please enter processing time",
                  },
                  {
                    validator: (_, value) =>
                      value < 0
                        ? Promise.reject(
                          new Error("Processing time cannot be negative")
                        )
                        : Promise.resolve(),
                  },
                ]}
              >
                <Input
                  type="number"
                  placeholder="Enter processing time"
                  className="w-full mt-1"
                  addonAfter={
                    <Form.Item name="processingUnit" noStyle initialValue="H">
                      <Select
                        className="[&_.ant-select-selector]:!min-h-[30px] [&_.ant-select-selector]:!py-0 [&_.ant-select-selector]:!rounded-none [&_.ant-select-selector]:!rounded-r-md"
                        options={[
                          { value: "H", label: "Hours" },
                          { value: "M", label: "Minutes" },
                        ]}
                      />
                    </Form.Item>
                  }
                />
              </Form.Item>
            </div>
            <div>
              <p className="font-semibold mb-[2px]">Fees</p>
              <Form.Item
                name="fees"
                rules={[
                  { required: true, message: "Please enter fees" },
                  {
                    validator: (_, value) =>
                      value < 0
                        ? Promise.reject(
                          new Error("Fees cannot be negative")
                        )
                        : Promise.resolve(),
                  },
                ]}
              >
                <Input
                  type="number"
                  step="0.01"
                  placeholder="Enter fees"
                  className="w-full mt-1"
                />
              </Form.Item>
            </div>
            <div>
              <p className="font-semibold mb-[2px]">Description</p>
              <Form.Item name="description">
                <Input
                  type="text"
                  placeholder="Enter description"
                  className="w-full mt-1"
                />
              </Form.Item>
            </div>
            {showCryptoAddressField && (
              <div className="md:col-span-2">
                <p className="font-semibold mb-[2px]">Crypto Address</p>
                <Form.Item name="cryptoAddress">
                  <Input
                    type="text"
                    placeholder="Enter crypto address"
                    className="w-full mt-1"
                  />
                </Form.Item>
              </div>
            )}
            {showQrField && (
              <div>
                <p className="font-semibold mb-[2px]">QR Code</p>
                <Form.Item
                  name="uploadQRCode"
                  rules={[
                    {
                      required: true,
                      message: "Please upload an image",
                    },
                  ]}
                >
                  <Upload
                    className="mt-1"
                    beforeUpload={() => false}
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleQrChange}
                  >
                    {fileList.length >= 1 ? null : UploadButton}
                  </Upload>
                </Form.Item>
                {previewImage && (
                  <Image
                    wrapperStyle={{ display: "none" }}
                    preview={{
                      visible: previewOpen,
                      onVisibleChange: (visible) => setPreviewOpen(visible),
                      afterOpenChange: (visible) =>
                        !visible && setPreviewImage(""),
                    }}
                    src={previewImage}
                  />
                )}
              </div>
            )}
          </div>

          <div className="flex justify-end mt-8">
            <LoadableButton
              className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-1.5 uppercase themeHover duration-500"
              type="submit"
              lable="Update"
              isLoading={isEditTraderLoading}
              loadingLable="Updating..."
            />
          </div>
        </Form>
      </ModalComponent>
    </div>
  );
}
